import { render, staticRenderFns } from "./AlbumListItem.vue?vue&type=template&id=7b310d42"
import script from "./AlbumListItem.vue?vue&type=script&lang=js"
export * from "./AlbumListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports